import { createApp } from '@app/adapters/create-app'

import InboxUnreadCount from '../../screens/inbox/components/inbox-unread-count.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='inbox-unread-count']").each(function () {
    const dataUrl = this.getAttribute('data-url')
    createApp(
      InboxUnreadCount,
      {
        url: dataUrl,
        className: this.getAttribute('data-class'),
      },
      {
        singletonId: `inbox-unread-count-${dataUrl}`,
      }
    ).mount(this)
  })
})
